export default __webpack_public_path__ + "static/media/ico-tilde.eb15b855.svg";